var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100MicRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F14646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 11.7007H8.90833C8.90833 12.1437 9.00167 12.5568 9.15917 12.928L8.44167 13.6643C8.115 13.0776 7.91667 12.4131 7.91667 11.7007ZM10.2617 11.8024C10.2617 11.7665 10.25 11.7366 10.25 11.7007V8.10855C10.25 7.11474 11.0317 6.3125 12 6.3125C12.9683 6.3125 13.75 7.11474 13.75 8.10855V8.21632L10.2617 11.8024ZM16.5092 6.91118L17.25 7.67151L13.7442 11.2696V11.7007C13.7442 12.6945 12.9683 13.4967 12 13.4967C11.8717 13.4967 11.7433 13.4787 11.6208 13.4488L10.6525 14.4426C11.0667 14.6402 11.5275 14.7539 12 14.7539C13.61 14.7539 15.0917 13.4967 15.0917 11.7007H16.0833C16.0833 13.7422 14.4967 15.4305 12.5833 15.7238V17.6875H11.4167V15.7238C10.8858 15.646 10.3842 15.4544 9.935 15.185L7.49083 17.6875L6.75 16.9272L16.5092 6.91118Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100MicRed);
export default __webpack_public_path__ + "static/media/100-mic-red.59bd8a9f266dc321979417953f2e3bca.svg";
export { ForwardRef as ReactComponent };